import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { GenericAkitaHTTPService, HttpOptions } from '../service/generic-akita-http.service';
import { Alert } from '../model/alert';
import { NetworkService } from '../service/network.service';

@Injectable({
  providedIn: 'root'
})
export class AkitaMissionHttpService extends GenericAkitaHTTPService<Alert> {
  constructor(http: HttpClient, networkService: NetworkService) {
    const options: HttpOptions = {
      params: {
        type: 'Alert',
        options: 'keyValues',
        limit: '50',
        orderBy: '!validFrom',
      }
    };
    super(http, networkService, '/v2/entities/', 'alert', options);
  }
}
